export interface AuthDialogData {
  open: boolean;
  title: string;
  subtitle: string;
  utmString: string;
}

export const initialAuthDialogData: AuthDialogData = {
  open: false,
  title: '',
  subtitle: '',
  utmString: '',
};

export const AuthDialogReducer = (state = initialAuthDialogData, action) => {
  switch (action.type) {
    case 'UPDATE_AUTH_DIALOG_DATA':
      return {...state, ...action.data};
    case 'CLOSE_AUTH_DIALOG':
      return {...initialAuthDialogData};
    default:
      return state;
  }
};
